import getElementTop from '../utilities/get-element-top';

const smoothScrollLinks = {

    elements: {},

    cacheDom()
    {
        this.elements.smoothScrollLinks = document.querySelectorAll('[href*="#"]');
    },

    bind()
    {
        if( this.elements.smoothScrollLinks )
        {
            this.elements.smoothScrollLinks.forEach( link => {
                
                const href = link.getAttribute('href');
                const hash = href.match(/#([a-zA-Z0-9-]+)/);

                if( hash && hash[0] )
                {
                    const fragment = document.querySelector(hash[0]);
                    if( fragment )
                    {
                        link.addEventListener('click', e => {
                            e.preventDefault();
                            
                            const activeClass = fragment.getAttribute('data-active-class');
                            if( activeClass === 'fade-in--active')
                            {
                                fragment.classList.add(activeClass);
                            }

                            setTimeout( () => {
                                let top = getElementTop(fragment);

                                window.scrollTo({
                                    top: top,
                                    behavior: 'smooth'
                                });
                            }, 100);

                        });
                    }
                }
            });
        }
    },

    init() {
        this.cacheDom();
        this.bind();
    }
}

export default smoothScrollLinks;